import * as React from 'react'
import styled from 'styled-components'
import { loadCatalogue } from '../frontend-lib/i18n'
import { I18nCatalogue } from '../frontend-lib/i18n/auth/types'
import { useAuthState } from '../frontend-lib/components/auth/useAuthState'
import { SocialAuth } from '../frontend-lib/components/auth/SocialAuth'
import { PasswordAuth } from '../frontend-lib/components/auth/PasswordAuth'
import { KamismaPageContext } from './_app'

interface Props {
  readonly catalogue: I18nCatalogue
}

const Auth = ({ catalogue }: Props) => {
  const pageState = useAuthState()
  const { initializing, pageMode, withPassword } = pageState

  if (initializing) {
    return null
  }

  return (
    <>
      <Title>
        {catalogue[pageMode].title}
        <br />
        {pageMode === 'signUp' && catalogue[pageMode].subTitle}
      </Title>
      {!withPassword && <SocialAuth catalogue={catalogue} pageState={pageState} />}
      {withPassword && <PasswordAuth catalogue={catalogue} pageState={pageState} />}
    </>
  )
}

Auth.getInitialProps = async ({ req, me }: KamismaPageContext) => {
  // TODO: Handle error=access_denied
  const catalogue = await loadCatalogue<I18nCatalogue>('auth', me, req)
  return { catalogue }
}

export default Auth

const Title = styled.h1`
  text-align: center;
  margin: 4rem 0 2rem;
`
